import { Inject, Singleton } from '@denishussar/html5-game-engine';
import { engineButtons, engineButtonState } from '../../Controllers/MiniGames/EngineGame/EngineButtonController';
import { EnginePowerUpModel } from '../../Models/MiniGames/PowerEnigineUpModel';
import { DialogTextEnum, DialogTypeTextEnum } from '../../Models/GameModel';
import { GameLogic } from '../GameLogic';

@Singleton
export class EngineLogic {
    constructor(
        @Inject private _model: EnginePowerUpModel,
        @Inject private _gameLogic: GameLogic,
    ) {

    }

    public buttonsClick(btn: number): void {
        if ((btn === engineButtons.contur1) || (btn === engineButtons.contur2)) {
            if (
                (this._model.btnStates[engineButtons.reactor1]) &&
                (this._model.btnStates[engineButtons.reactor2])
            ) {
                this._model.btnStates[btn] = engineButtonState.active;
                return;
            } else {
                this._model.showDialog = true;
                this._gameLogic.showDialogScreen(DialogTextEnum.engine, DialogTypeTextEnum.hint, this.getHintIndex());
                return;
            }
        }
        if (btn === engineButtons.turbine) {
            if (
                (this._model.btnStates[engineButtons.reactor1]) &&
                (this._model.btnStates[engineButtons.reactor2]) &&
                (this._model.btnStates[engineButtons.contur1]) &&
                (this._model.btnStates[engineButtons.contur2])
            ) {
                this._model.btnStates[btn] = engineButtonState.active;
                return;
            } else {
                this._model.showDialog = true;
                this._gameLogic.showDialogScreen(DialogTextEnum.engine, DialogTypeTextEnum.hint, this.getHintIndex());
                
                return;
            }
        }
        if (btn === engineButtons.generator) {
            if (
                (this._model.btnStates[engineButtons.reactor1]) &&
                (this._model.btnStates[engineButtons.reactor2]) &&
                (this._model.btnStates[engineButtons.contur1]) &&
                (this._model.btnStates[engineButtons.contur2]) &&
                (this._model.btnStates[engineButtons.turbine])
            ) {
                this._model.btnStates[btn] = engineButtonState.active;
                return;
            } else {
                this._model.showDialog = true;
                this._gameLogic.showDialogScreen(DialogTextEnum.engine, DialogTypeTextEnum.hint, this.getHintIndex());
                return;
            }
        }
        if (btn === engineButtons.powerUp) {
            if (
                (this._model.btnStates[engineButtons.reactor1]) &&
                (this._model.btnStates[engineButtons.reactor2]) &&
                (this._model.btnStates[engineButtons.contur1]) &&
                (this._model.btnStates[engineButtons.contur2]) &&
                (this._model.btnStates[engineButtons.turbine]) &&
                (this._model.btnStates[engineButtons.generator])
            ) {
                this._model.btnStates[btn] = engineButtonState.active;
                return;
            } else {
                this._model.showDialog = true;
                this._gameLogic.showDialogScreen(DialogTextEnum.engine, DialogTypeTextEnum.hint, 3);
                return;
            }
        }
        this._model.btnStates[btn] = engineButtonState.active;
    }

    private getHintIndex(): number {
        if (!(this._model.btnStates[engineButtons.reactor1] && this._model.btnStates[engineButtons.reactor2])) {
            return 0;
        }
        if ((this._model.btnStates[engineButtons.reactor1] && this._model.btnStates[engineButtons.reactor2]) &&
            !(this._model.btnStates[engineButtons.contur1] && this._model.btnStates[engineButtons.contur2])
        ) {
            return 1;
        }
        if ((this._model.btnStates[engineButtons.contur1] && this._model.btnStates[engineButtons.contur2]) &&
            !(this._model.btnStates[engineButtons.turbine])
        ) {
            return 2;
        }

        return 0;
    }
}
